var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 43,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.494141 29.5054H15.0468H29.5051V0.494385H0.494141V29.5054Z",
    fill: "url(#paint0_linear_10876_1215)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.494141 29.5053V0.657471V0.671976L15.0468 11.3734V29.5053H0.494141Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1203 25.5164H11.373V24.0658H4.1203V25.5164Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10876_1215",
    x1: 7.93909,
    y1: 7.93933,
    x2: 28.8197,
    y2: 28.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF45ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B74AF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009AE5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLogo);
export default __webpack_public_path__ + "static/media/mobile-logo.25f70594.svg";
export { ForwardRef as ReactComponent };